import {
  Component,
  signal
} from '@angular/core';

import {
  Router,
  RouterOutlet,
  NavigationEnd
} from '@angular/router';

import {
  Header
} from './components/header/header';

import {
  Footer
} from './components/footer/footer';

import {
  CommonModule
} from '@angular/common';

import {
  filter
} from 'rxjs/operators';


@Component({
  selector: 'app-root',

  imports: [
    CommonModule,
    RouterOutlet,
    Header,
    Footer
  ],

  templateUrl: './app.html',

  styleUrl: './app.css'
})
export class App {

  protected readonly title =
    signal('paraiso-do-cerrado');


  rotaAtual = '';


  constructor(
    private router: Router
  ) {

    this.router.events
      .pipe(
        filter(
          evento =>
            evento instanceof NavigationEnd
        )
      )
      .subscribe(
        (evento: NavigationEnd) => {

          this.rotaAtual =
            evento.urlAfterRedirects;

        }
      );

  }


  isAdminRoute(): boolean {

    return this.rotaAtual.startsWith('/admin');

  }

}
